import { Button, Modal } from "../../atoms";
import Flexbox from "../../common/Flexbox";

type Props = {
  isOpen: boolean;
  onClose: VoidFunction;
  handleDelete: VoidFunction;
};

const DeleteWidgetModal = ({ isOpen, onClose, handleDelete }: Props) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Supprimer le widget"
      className="w-[600px]"
    >
      <Flexbox className="gap-2">
        <p className="text-xs font-normal text-neutral-600">
          Êtes-vous sûr de vouloir supprimer ce widget ?
        </p>

        <Flexbox row fullWidth justify="end" className="mt-4 gap-2">
          <Button
            onClick={onClose}
            className="w-fit border border-tertiary-800 bg-transparent text-tertiary-800"
          >
            Annuler
          </Button>
          <Button onClick={handleDelete} theme="danger" className="w-fit">
            Supprimer
          </Button>
        </Flexbox>
      </Flexbox>
    </Modal>
  );
};

export default DeleteWidgetModal;
